// custom-metaobject-search.js
const STOREFRONT_TOKEN = '3e8feaa6906731977f1936013555c847'; 
const SHOP_DOMAIN = '3mile.ca'; 

// THE SHORT-TERM MEMORY BANK
let cachedMetaobjects = [];
let isDataLoaded = false;

// THE PAGE-FLIPPER: Automatically gets every item, even if you have thousands
async function fetchAllFromFolder(folderType) {
  let allNodes = [];
  let hasNextPage = true;
  let cursor = null;

  while (hasNextPage) {
    const cursorString = cursor ? `, after: "${cursor}"` : '';
    const query = `
      {
        metaobjects(type: "${folderType}", first: 250${cursorString}) {
          pageInfo { hasNextPage endCursor }
          nodes { handle type fields { key value } }
        }
      }
    `;

    try {
      const response = await fetch(`https://${SHOP_DOMAIN}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query })
      });
      
      const data = await response.json();
      const folderData = data?.data?.metaobjects;
      
      if (folderData?.nodes) {
        allNodes = [...allNodes, ...folderData.nodes];
      }
      
      // Check if there is another page of data to fetch
      hasNextPage = folderData?.pageInfo?.hasNextPage || false;
      cursor = folderData?.pageInfo?.endCursor || null;
    } catch (error) {
      console.error('3 Mile Download Error:', error);
      hasNextPage = false;
    }
  }
  return allNodes;
}

// THE PRE-LOADER: Runs automatically in the background on page load
async function preLoadData() {
  const trails = await fetchAllFromFolder("routes_and_trails");
  const events = await fetchAllFromFolder("local_events");
  
  cachedMetaobjects = [...trails, ...events];
  isDataLoaded = true;
  console.log(`3 Mile Brain Loaded: ${cachedMetaobjects.length} total local items stored in memory.`);
}

// Start the download immediately!
preLoadData();

// THE TRIGGER: Now searches the "Memory" instead of the API
document.addEventListener('input', (e) => {
  if (e.target && e.target.classList.contains('3mile-search-trigger')) {
    const searchTerm = e.target.value;
    const resultsContainer = document.getElementById(`3mile-results-${e.target.id}`);
    const contentContainer = document.getElementById(`3mile-results-content-${e.target.id}`);
    
    if (!resultsContainer || !contentContainer) return;

    // Won't search if they haven't typed 3 letters OR if the background download isn't finished yet
    if (searchTerm.length < 3 || !isDataLoaded) {
      resultsContainer.style.display = 'none';
      return;
    }

    // INSTANT SEARCH: Scans the memory bank
    const results = cachedMetaobjects.filter(node => 
      JSON.stringify(node.fields).toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    // Inject results using 3 Mile visual standards
    if (results.length > 0) {
      let html = '';
      
      // Optional: limit dropdown to 5 items so it doesn't cover the whole screen if there are a ton of matches
      const topResults = results.slice(0, 10); 

      topResults.forEach(item => {
        const nameField = item.fields.find(f => f.key === 'title' || f.key === 'name');
        const title = nameField ? nameField.value : item.handle.replace(/-/g, ' ');
        const buttonText = item.type === 'local_events' ? 'View Event' : 'View Trail';
        
        const folderPath = item.type.replace(/_/g, '-'); 
        const finalUrl = `/pages/${folderPath}/${item.handle}`;
        
        html += `
          <div style="padding: 12px 0; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f0f0f0;">
            <span style="font-size: 1.4rem; font-weight: normal; color: #1a1a1a; letter-spacing: 0.02em; text-transform: capitalize;">${title}</span>
            <a href="${finalUrl}" class="custom-search-action-btn">${buttonText}</a>
          </div>
        `;
      });
      contentContainer.innerHTML = html;
      resultsContainer.style.display = 'block';
    } else {
      resultsContainer.style.display = 'none';
    }
  }
});